import { useMemo } from "react";
import useDebouncedValue from "hooks/useDebouncedValue";
import { emptyAuthFor } from "ai-management/providerAuth";
import generateId from "logic/generateId";
import useModelsQuery from "ai-management/hooks/useModelsQuery";
const SETTLE_MS = 750;
const toListArg = (credentials) => {
  var _a;
  return {
    provider: credentials.provider,
    auth: (_a = credentials.auth) != null ? _a : emptyAuthFor(credentials.provider)
  };
};
const useModels = (provider, credentials) => {
  const [settled] = useDebouncedValue(credentials, SETTLE_MS);
  const serialised = settled ? JSON.stringify(settled) : void 0;
  const credentialKey = useMemo(() => serialised ? generateId() : "none", [serialised]);
  return useModelsQuery(provider, credentialKey, settled ? toListArg(settled) : void 0, !settled);
};
export default useModels;
